import {FortuneUserPrizeGenqlSelection} from "@/gql/gen";

export const FortuneUserPrizeFields: FortuneUserPrizeGenqlSelection = {
    ID: true,
    USER_ID: true,
    IS_USED: true,
    PRIZE_ELEMENT_ID: true,
}




